export default __webpack_public_path__ + "static/GY_TEXT-1d91905cd63a676f9e5340b89f16f601.png";